import { useEffect, useMemo, useState } from 'react'

import { TEST_SYSTEM_NOTICE, loadCatalogueUnverified } from '../lib/catalogueMode.ts'
import { readPublicConfig } from '../lib/env.ts'

/**
 * The test-system banner for every page that does not load the menu itself:
 * the return page, the survey, the console and the print views. The customer
 * page draws its own from the context it already holds (`page/shell.tsx`).
 *
 * Both languages at once, because these pages have no language switch of
 * their own and the customer may be reading either. Styled inline, because
 * the customer page and the console share no stylesheet (`router.tsx`).
 */
export function SiteNotice(): JSX.Element | null {
  const config = useMemo(() => readPublicConfig(), [])
  const [show, setShow] = useState(false)
  useEffect(() => {
    let live = true
    void loadCatalogueUnverified(config).then((answer) => {
      if (live) setShow(answer)
    })
    return () => {
      live = false
    }
  }, [config])
  if (!show) return null
  return (
    <div
      className="banner site-notice"
      data-testid="site-notice"
      role="note"
      style={{ background: '#fff4d6', color: '#5a4300', padding: '8px 16px', fontSize: 14, textAlign: 'center' }}
    >
      {TEST_SYSTEM_NOTICE.hu}
      <br />
      <span lang="en">{TEST_SYSTEM_NOTICE.en}</span>
    </div>
  )
}
